module.exports = __webpack_public_path__ + "img/28_52.c055c19b.png";